import { render, staticRenderFns } from "./PersonLocationData.vue?vue&type=template&id=624e2ee4"
import script from "./PersonLocationData.vue?vue&type=script&lang=js"
export * from "./PersonLocationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports